import { Component, OnInit, Renderer2, Inject } from '@angular/core';

@Component({
  selector: 'app-badgateway',
  templateUrl: './badgateway.component.html',
  styleUrls: ['../error.component.scss']
})
export class badgatewayComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }
}
